import React from "react";
import { Modal } from "react-bootstrap";

interface CouponModalProps {
  onClose: () => void;
  shouldShow: boolean;
  image: string;
}

export default function CouponModal({ onClose, shouldShow, image }: CouponModalProps) {
  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body bsPrefix={"main-container"}>
          <div className="modal-body">
            <img src={image} style={{ width: "100%" }} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
            <button type="button" className="rkmd-btn btn-lg btn-black ripple-effect w-100 mt-3">
              <a
                href={image}
                download
                // onClick={onClose}
                target="_blank"
                rel="noreferrer"
              >
                Download
              </a>
            </button>
          </div>
          <div className="btn-wrap mb-3">
            <button type="button" className="rkmd-btn btn-lg btn-red ripple-effect w-100 mt-3" onClick={onClose}>
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
